import { type FC } from 'react';

import { CarouselMainContainer } from 'shared/components/Carousel';
import { AdfoxPixelContainer } from 'shared/containers/AdfoxPixel';
import { Promos } from 'shared/containers/Promos';
import { MortgageCalculatorContainer } from 'shared/packages/mortgage-calculator';

import { AboutContainer } from '../About';
import { AwardsContainer } from '../Awards';
import { ContentWrapper } from '../ContentWrapper';
import { FactsContainer } from '../Facts';
import { HeaderContainer } from '../Header';
import { PikHistoryContainer } from '../PikHistory';
import { PikInNumbersContainer } from '../PikInNumbers';
import { PikProjectsContainer } from '../PikProjects';
import { RatingsContainer } from '../Ratings';
import { SeriaPlusContainer } from '../SeriaPlus';
import { EnvironmentForLifeAndBusinessContainer, ProductFeaturesOfTheQuarters } from '../SliderBlockTypeOne';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { PikInNumbersV2Container } from '../PikInNumbersV2';

export const ApplicationContent: FC = () => {
  const { config } = useApplicationContext();

  const isDesignV2Enabled = !!config.get<boolean>('Martech.PikLanding.DesignV2.Enabled');

  return (
    <div data-testid="ApplicationContent">
      <CarouselMainContainer />
      <ContentWrapper>
        <HeaderContainer />
        <FactsContainer />
        <Promos />
        <PikProjectsContainer />
        <SeriaPlusContainer />
        <MortgageCalculatorContainer />
        {isDesignV2Enabled ? <PikInNumbersV2Container /> : <PikInNumbersContainer />}
        <EnvironmentForLifeAndBusinessContainer />
        <ProductFeaturesOfTheQuarters />
        <PikHistoryContainer />
        <RatingsContainer />
        <AwardsContainer />
        <AboutContainer />
        <AdfoxPixelContainer />
      </ContentWrapper>
    </div>
  );
};
